import React from 'react';
import { Stack } from '../../navigation/stackNavigation';
import {
  Dashboard as DashboardScreen,
  SignIn as SignInScreen,
  OTPValidation as OTPValidationScreen,
  SAC as SACScreen,
  About as AboutScreen,
  Settings as SettingsScreen,
  Invoices as InvoicesScreen,
} from '~/credsystem/scenes';

export const CredsystemNavigation = (
  <>
    <Stack.Screen
      name="Credsystem_Dashboard"
      component={DashboardScreen}
      options={{ headerShown: false }}
    />
    <Stack.Screen
      name="Credsystem_SignIn"
      component={SignInScreen}
      options={{ headerShown: false }}
    />
    <Stack.Screen
      name="Credsystem_OTPValidation"
      component={OTPValidationScreen}
      options={{ headerShown: false }}
    />
    <Stack.Screen
      name="Credsystem_SAC"
      component={SACScreen}
      options={{ headerShown: false }}
    />
    <Stack.Screen
      name="Credsystem_About"
      component={AboutScreen}
      options={{ headerShown: false }}
    />
    <Stack.Screen
      name="Credsystem_Settings"
      component={SettingsScreen}
      options={{ headerShown: false }}
    />
    <Stack.Screen
      name="Credsystem_Invoices"
      component={InvoicesScreen}
      options={{ headerShown: false }}
    />
  </>
);
